import { Component } from 'react';
import cx from 'classnames';
import { makeid, CDN_CLRSAVE_URL } from '../../constants';
import styles from '../../styles/homePage/planCardPopup.scss';
import commonStyles from '../../styles/index.scss';
import { Router } from '../../configs/routes';

interface Props {
  fund: any;
  editing: boolean;
  _length: number;
  isVariant?: boolean;
  disabledClass: string;
  removed: boolean;
  changeFund: any;
}

function renderFundItem(value: string, isRating: boolean) {
  return (
    <div className="inline-block" key={makeid()}>
      <p className={cx('text--xmd', styles['fund-detail'])}>
        {value.replace(/\/5/g, '')}
        {isRating ? (
          <img
            width="32"
            src={`${CDN_CLRSAVE_URL}/clearsave/images/star.svg`}
            alt={value}
          />
        ) : null}
      </p>
    </div>
  );
}

class FundItem extends Component<Props> {
  public handleClick = (e: any) => {
    e.stopPropagation();
    const { fund } = this.props;
    const { fundMetaData, planType = 'GROWTH' } = fund;
    if (fundMetaData) {
      const { slug, parentSlug, isinCode } = fundMetaData;
      if (slug && parentSlug && isinCode) {
        Router.pushRoute(
          `/mutual-funds/${parentSlug}/${slug}/${isinCode}?ref=plan&planType=${planType}`
        );
      }
    }
  };

  public render() {
    const {
      fund,
      editing,
      _length,
      isVariant,
      disabledClass,
      removed,
      changeFund,
    } = this.props;

    return (
      <li
        className={cx(styles.fund, disabledClass)}
        onClick={this.handleClick}
        key={makeid()}
      >
        <div className="row">
          <div className="large-1 small-2 columns">
            <div className={cx('float--left', styles['fund-image-wrapper'])}>
              <img
                className={styles['fund-image']}
                src={`${CDN_CLRSAVE_URL}/clearsave${fund.imageUrl}`}
                alt={fund.fundName}
              />
            </div>
          </div>
          <div className="large-7 small-5 columns">
            <div className={styles['fund-info']}>
              <label
                className={cx(
                  'block text--md ml10 float--left',
                  styles['fund-name']
                )}
              >
                {fund.fundName}
              </label>
              <p className={cx(styles['fund-focus'])}>
                {fund.fundFocus}
                <br />
                {isVariant ? (
                  <span className="underline-hover font--blue-solid cursor--pointer">
                    More Info
                  </span>
                ) : null}
              </p>
            </div>
          </div>
          <div
            className={cx('large-4 small-5 columns', styles['no-padding-left'])}
          >
            <div className="row">
              <div className="large-6 small-6 columns">
                {renderFundItem(
                  `${fund.fundMetaData.returns.return3yr}%`,
                  false
                )}
              </div>

              <div className={cx('large-6 small-6 columns')}>
                {renderFundItem(
                  `${fund.fundMetaData.returns.return5yr}%`,
                  false
                )}
                {editing && removed ? (
                  <a
                    onClick={(e) =>
                      changeFund(e, fund.productId, fund.fundName)
                    }
                    className={cx(
                      'inline-block',
                      commonStyles['fr'],
                      styles.delete
                    )}
                    href="#"
                  >
                    <img src="https://assets1.cleartax-cdn.com/ct-frontend/images/addBack.svg" />
                  </a>
                ) : null}
                {editing && !removed && _length > 1 ? (
                  <a
                    onClick={(e) =>
                      changeFund(e, fund.productId, fund.fundName)
                    }
                    className={cx(
                      'inline-block',
                      commonStyles['fr'],
                      styles.delete
                    )}
                    href="#"
                  >
                    <img src="https://assets1.cleartax-cdn.com/ct-frontend/images/delete.svg" />
                  </a>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <div className={styles['fund-details']}>
          {/* <p
          className={cx(
            styles['detail-value'],
            'inline-block',
            commonStyles['fr']
          )}
        >
          ₹{fund.amount}
        </p> */}
        </div>
      </li>
    );
  }
}

export default FundItem;



// WEBPACK FOOTER //
// ./components/plan/fundItem.tsx